import { Route, Routes } from "react-router-dom";
import { SocInvoiceDataCreate } from "./soc-invoce-data/SocInvoiceDataCreate";
import { SocInvoiceDatas } from "./soc-invoce-data/SocInvoiceDatas";

const Router = () => (
  <Routes>
    <Route path="soc-invoice-data" element={<SocInvoiceDatas />} />
    <Route path="soc-invoice-data/create" element={<SocInvoiceDataCreate />} />
  </Routes>
);

export default Router;
